import React from 'react';
import FilterMultiSelectList from './filters/FilterMultiSelectList';
import FilterMultiSelectDropdown from './filters/FilterMultiSelectDropdown';
import FilterSingleSelectList from './filters/FilterSigneSelectList';
import FilterSingleSelectDropdown from './filters/FilterSingleSelectDropdown';
import FilterRangeField from './filters/FilterRangeField';

const useRenderFiltersFragment = () => {
    const renderFiltersFragment = ({filters, setFilters, filtersInitial, loading}) => {
        const filtersCountry = [];
        const filtersIndustry = [];
        const filtersCategory = [];
        const filtersRest = [];

        for (const filter of Object.values(filters.filters)) {
            switch (filter.name) {
                case 'industry':
                    filtersIndustry.push(filter);
                    break
                case 'country':
                    filtersCountry.push(filter);
                    break
                default:
                    if (filter.name.startsWith('category-')) {
                        filtersCategory.push(filter)
                    } else {
                        filtersRest.push(filter)
                    }
                    break
            }
        }

        // SORT

        const filtersCategorySorted = filtersCategory.sort((a, b) => {
            if (a.index < b.index) {
                return -1;
            } else if (a.index > b.index) {
                return 1;
            }
            return 0;
        });

        const fragmentCountry = [];
        const fragmentIndustry = [];
        const fragmentCategory = [];
        const fragmentRest = [];

        const assignFragment = (filtersList, fragment) => {
            for (const filter of filtersList) {
                // console.log(filter)
                const filterProps = {
                    key: `filter-${filter.name}`,
                    filters,
                    setFilters,
                    filter,
                    APIOptions: filter.config.APIOptions,
                    filtersInitial,
                    loading,
                }
                switch (filter.type) {
                    case 'multi-select':
                        switch (filter.config.variant) {
                            case 'list':
                                fragment.push(<FilterMultiSelectList {...filterProps} />);
                                break
                            case 'dropdown':
                                fragment.push(<FilterMultiSelectDropdown {...filterProps} />);
                                break
                            default:
                                break
                        }
                        break
                    case 'single-select':
                        switch (filter.config.variant) {
                            case 'list':
                                fragment.push(<FilterSingleSelectList {...filterProps} />);
                                break
                            case 'dropdown':
                                fragment.push(<FilterSingleSelectDropdown {...filterProps} />);
                                break
                            default:
                                break
                        }
                        break
                    case 'range':
                        fragment.push(<FilterRangeField {...filterProps} />);
                        break
                    default:
                        break
                }
            }
            return true
        }

        assignFragment(filtersCountry, fragmentCountry);
        assignFragment(filtersIndustry, fragmentIndustry);
        assignFragment(filtersCategorySorted, fragmentCategory);
        assignFragment(filtersRest, fragmentRest);
        // console.log(fragmentCountry);
        // console.log(fragmentIndustry);
        // console.log(fragmentCategory);
        // console.log(fragmentRest);

        return <>{[...fragmentCountry, ...fragmentIndustry, ...fragmentCategory, ...fragmentRest]}</>
    }

    return renderFiltersFragment;
}

export default useRenderFiltersFragment;
